import { useRef, useState } from "react";
import { Archive, Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Panel } from "./common";
import { Button } from "./ui/button";
import { VigImportRemove } from "./VigImportRemove";

export function VigImport({ onDone }) {
  const file = useRef(null);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const upload = (e) => {
    const fl = e.target.files?.[0]; e.target.value = "";
    if (!fl) return;
    const rd = new FileReader();
    rd.onload = async () => {
      setBusy(true);
      try { const d = await api("/local/vig-reports/import", { method: "POST", body: { data: rd.result } }); setRes(d); toast.success(`${d.imported} report importati`); onDone?.(); }
      catch (err) { toast.error(err.message); } finally { setBusy(false); }
    };
    rd.readAsDataURL(fl);
  };
  return (
    <Panel className="mb-6" data-testid="vig-import-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-semibold text-[var(--navy)] flex items-center gap-2"><Archive className="w-4 h-4" />Archivio report Vigilpol</h3>
          <p className="text-xs text-slate-500 mt-1">Carica l'export Excel di Vigilpol: i report già importati vengono saltati, quindi puoi ricaricare il file aggiornato.</p>
        </div>
        <Button variant="outline" className="rounded-full" disabled={busy} onClick={() => file.current?.click()} data-testid="vig-import-upload">{busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Upload className="w-4 h-4 mr-1" />}Importa file Excel</Button>
        <input ref={file} type="file" accept=".xlsx" className="hidden" onChange={upload} data-testid="vig-import-file" />
      </div>
      {res && (
        <div className="mt-4 text-sm text-slate-600 space-y-2" data-testid="vig-import-result">
          <p><b>{res.imported}</b> importati · {res.already} già presenti · {res.duplicates} righe doppie nel file{res.invalid ? ` · ${res.invalid} senza data valida` : ""}</p>
          {res.matched.length > 0 && <p><b>Associati a utenti esistenti:</b> {res.matched.join("; ")}</p>}
          {res.unmatched.length > 0 && <p data-testid="vig-import-unmatched"><b>Non trovati tra gli utenti (resta il nome del file):</b> {res.unmatched.join("; ")}</p>}
        </div>
      )}
      <VigImportRemove />
    </Panel>
  );
}
